export const LEVEL01_BGM_KEY = "level01-mutant-mayhem";
export const LEVEL01_BGM_URL = "/assets/audio/level01-mutant-mayhem.mp3";
export const LEVEL01_BOSS_BGM_KEY = "level01-sam-altman-glitch-boss";
export const LEVEL01_BOSS_BGM_URL = "/assets/audio/level01-sam-altman-glitch-boss.mp3";
export const LEVEL01_BGM_VOLUME = 0.42;
export const LEVEL01_BGM_FADE_MS = 480;

export function shouldLoopLevel01Theme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
  silencedForBoss: boolean;
}): boolean {
  if (input.levelIndex !== 0) return false;
  if (input.practiceBossStart) return false;
  if (input.silencedForBoss) return false;
  return input.activeWaveId !== "boss";
}

export function shouldLoopLevel01BossTheme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
  silencedForBoss: boolean;
}): boolean {
  if (input.levelIndex !== 0) return false;
  if (input.practiceBossStart) return true;
  if (input.silencedForBoss) return true;
  return input.activeWaveId === "boss";
}
